import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];
const reveal = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.15 },
  transition: { duration: 0.7, ease: EASE },
};

const STEPS = [
  {
    n: "01",
    t: "Anamnese & diagnóstico",
    d: "Formulário detalhado sobre rotina, histórico de lesões, exames e preferências alimentares.",
  },
  {
    n: "02",
    t: "Protocolo em até 48h",
    d: "Planilha de treino e plano alimentar construídos do zero para o seu biotipo e objetivo.",
  },
  {
    n: "03",
    t: "Execução & acompanhamento",
    d: "Treino, dieta e avaliações centralizados no app da Prime Coaching, com meu suporte direto pelo WhatsApp.",
  },
  {
    n: "04",
    t: "Reavaliação & lapidação",
    d: "Check-ins quinzenais para mensurar evolução e reajustar cargas e calorias.",
  },
];

export default function Method() {
  return (
    <section id="metodo" className="section-pad border-t border-white/10">
      <div className="container-x">
        <motion.div {...reveal}>
          <p className="overline-label">O processo</p>
          <h2 className="h2-display mt-4 text-white">Como funciona.</h2>
        </motion.div>

        <div className="mt-14">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.6, delay: i * 0.06, ease: EASE }}
              className={`group grid grid-cols-[auto_1fr_auto] items-center gap-5 border-t border-white/10 px-4 py-8 transition-colors duration-300 last:border-b hover:bg-white md:grid-cols-[140px_1fr_auto] md:gap-10 md:px-8 md:py-10 ${
                i === STEPS.length - 1 ? "border-b" : ""
              }`}
            >
              <span className="font-display text-4xl font-black text-white/15 transition-colors duration-300 group-hover:text-black/20 md:text-6xl">
                {s.n}
              </span>
              <div>
                <h3 className="font-display text-xl font-bold uppercase tracking-tight text-white transition-colors duration-300 group-hover:text-black md:text-3xl">
                  {s.t}
                </h3>
                <p className="mt-2 max-w-xl text-sm leading-relaxed text-white/50 transition-colors duration-300 group-hover:text-black/70 md:text-base">
                  {s.d}
                </p>
              </div>
              <ArrowUpRight className="h-6 w-6 text-white/20 transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-black md:h-9 md:w-9" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
